import instance from '@/service/instance';
import {Practice} from '@/helpers/types'

const resource: string = '/practice';

export default {
  async list(token: string): Promise<Practice[]> {
    const { data } = await instance.get(`${resource}/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return data.data;
  }
};
